module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "tranche-details"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Szczegóły wpłaty " + _vm._s(_vm.tranche.token))])]), _vm._v(" "), _c('template', {
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "saldo"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm._f("currency")(_vm.tranche.amount)
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Kwota wynagrodzenia")])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "inside-line"
  }, [_vm._v("\n        Dane do wysłania\n      ")])]), _vm._v(" "), _c('invoice-details', {
    attrs: {
      "token": _vm.tranche.token
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line status-changes-details"
  }, [_c('div', {
    staticClass: "inside-line"
  }, [_vm._v("\n        Szczegóły aktualizacji statusu\n      ")])]), _vm._v(" "), _c('table', {
    staticClass: "highlight centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data aktualizacji")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tranche.changes), function(change) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(change.updated_at)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.status))])])
  }), 0)])], 1), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "mfind-icon-back"
  }), _vm._v(" Zamknij\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-044d5bbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalTrancheHistory.vue
// module id = 357
// module chunks = 0